// Shared presentation for waveform overlays and cluster comparison columns.
export const waveformClusterColor = id => `hsl(${(Number(id) * 137) % 360}, 70%, 60%)`;

export const waveformAxis = title => ({
  title: { text: title, standoff: 4 },
  automargin: true,
  gridcolor: 'rgba(64, 224, 208, 0.2)',
  zerolinecolor: 'rgba(64, 224, 208, 0.4)',
  color: '#e0e6ed',
});

export const waveformLayout = () => ({
  autosize: true,
  // Retain toolbar zoom/pan when highlights or reference lines trigger a render.
  uirevision: 'waveform',
  paper_bgcolor: 'rgba(30, 30, 60, 0.6)',
  plot_bgcolor: 'rgba(0, 0, 0, 0.3)',
  font: { color: '#e0e6ed', size: 11 },
  xaxis: waveformAxis('Time (ms)'),
  yaxis: waveformAxis('Waveforms'),
  hovermode: 'closest',
  showlegend: false,
  margin: { l: 44, r: 14, t: 20, b: 42 },
});

export const waveformConfig = {
  responsive: true,
  scrollZoom: true,
  displayModeBar: true,
  displaylogo: false,
  modeBarButtonsToRemove: ['lasso2d', 'select2d'],
};
